<template>
  <div class="header">
    <div class="title">
      {{title}}
    </div>
    <div class="desc fs18">
      <div v-for="d in desc">{{d}}</div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'AUHeader',
   props: {
   },
   computed: {
     title() {
       return '关于全球青少年人工智能算法挑战活动（中国赛）'
     },
     desc() {
       return this.$store.state.aboutus.desc;
     }
   },
   components: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .header{
   height: 25.83vw;
   /* background-image: url(~@/assets/image/aboutus/header.png); */
   background-image: url('/oss/images/aboutus/header-2021.png');
   background-size: 100vw;
   display: flex;
   flex-direction: column;
   align-items: center;
   color: white;
   justify-content: center;
   font-weight: 400;
 }
 .title{
   font-size: 1.875vw;
 }
 .desc{
   max-width: 57.86vw;
   margin-top: 2vw;
 }
 .desc>div{
   text-align: center;
   margin-bottom: 0.5vw;
 }
</style>
